import{sendAnalytics as o}from"@front-core/analytics-event";import{getCustomParamsCH2 as r}from"./metrics.helper.es.js";const t=t=>{const e=r();o({...t,...e})};export{t as sendToCH2};
